import { render, staticRenderFns } from "./ModalComercio.vue?vue&type=template&id=b310e33a&scoped=true&"
import script from "./ModalComercio.vue?vue&type=script&lang=js&"
export * from "./ModalComercio.vue?vue&type=script&lang=js&"
import style0 from "./ModalComercio.vue?vue&type=style&index=0&id=b310e33a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b310e33a",
  null
  
)

export default component.exports